import { ConfigProvider } from 'antd';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ToastContainer } from 'react-toastify';
import UserContext from 'src/admin/views/UserContext';
import { swrConfig } from 'src/lib/swr';
import { themeConfig } from 'src/lib/theme';
import { MainRouter } from 'src/router/router';
import { SWRConfig } from 'swr';

export function App() {
  return (
    <ConfigProvider theme={themeConfig}>
      <ToastContainer />
      <SWRConfig value={swrConfig}>
        <UserContext>
          <DndProvider backend={HTML5Backend}>
            <MainRouter />
          </DndProvider>
        </UserContext>
      </SWRConfig>
    </ConfigProvider>
  );
}
